import{__awaiter as e}from"../../../../../node_modules/tslib/tslib.es6.js";import{unlikelyProductInputToProductRequestParams as i}from"../utils/unlikelyProductInputToProductRequestParams.js";import{shopifyStorefrontClientWrapper as t}from"../../../../../lib/clients.js";import{handleError as r}from"../../../../../lib/error-handler.js";import{gql as o}from"graphql-request";import{STOREFRONT_METAFIELD_FRAGMENT as n}from"../../fragments/metafields.js";import{PRODUCT_PARAMS as a,PRODUCT_FRAGMENT as d}from"../../fragments/product.js";import{shopifyVariantToUnlikelyVariant as l}from"../utils/serializers.js";import{getMetafieldIdentifiers as u}from"../../../../../lib/metafields.js";const s=o`
  query getVariantById(
    $id: ID!
    $language: LanguageCode
    $country: CountryCode
    $includeProduct: Boolean!
    $includeProductVariantMetafields: Boolean!
    $metafieldProductVariantIdentifiers: [HasMetafieldsIdentifier!]!
    ${a}
  ) @inContext(language: $language, country: $country) {
    node(id: $id) {
      ... on ProductVariant {
        id
        title
        sku
        availableForSale
        metafields(identifiers: $metafieldProductVariantIdentifiers)
        @include(if: $includeProductVariantMetafields) {
          ${n}
        }
        product @include(if: $includeProduct) {
          ${d}
        }
        quantityAvailable @include(if: $includeQuantityAvailable)
      }
    }
  }
`,c=t(((t,o)=>e(void 0,void 0,void 0,(function*(){var e;const n=u(o.metafieldProductVariantKeys),a=yield t.request(s,Object.assign({id:o.id,language:o.language,country:o.country,includeProduct:null!==(e=o.includeProduct)&&void 0!==e&&e,includeProductVariantMetafields:n.length>0,metafieldProductVariantIdentifiers:n},i(o)));return{errors:r(null==a?void 0:a.errors),variant:(null==a?void 0:a.node)?l(a.node):null}}))));export{c as sfVariant};
//# sourceMappingURL=variant.js.map
